export default __webpack_public_path__ + "static/media/fauna-index-building.54f06c94.png";